import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import DataStore from '../base/plumbing/DataStore';
import ServerIO from '../plumbing/ServerIO';
import Money from '../base/data/Money';
import LinkOut from '../base/components/LinkOut';
import KStatus from '../base/data/KStatus';

import C from '../C';
import ListLoad from '../base/components/ListLoad';
import { noVal } from '../base/utils/miscutils';

function DonationPage() {
	const path = DataStore.getValue(['location', 'path']);
	const pathId = path[1];

	// Loading CRM Data
	let campiagnList = [];
	let cidList = [];

	const dataListing = DataStore.getValue('data', 'crm');
	if (!dataListing) {
		DataStore.fetch( // Fetch only when needed
			['data', 'crm'], () => ServerIO.getDonationsCrm({})
		);
	} else {
		campiagnList = Object.keys(dataListing.campaign);
		cidList = Object.keys(dataListing.cid);
	}

	const [type, setType] = useState(C.TYPES.NGO);
	const typeLowercase = type.toLowerCase();

	const donationTypes = [
		{ name: 'Charity', value: C.TYPES.NGO },
		{ name: 'Campaign', value: C.TYPES.Campaign },
	];

	const noId = noVal(pathId) || pathId === '';

	function DonationDetails() {
		const idString = type === C.TYPES.NGO ? "cid" : "campaign";
		const mondayBoardId = type === C.TYPES.NGO ? "2506405019" : "2643467896";
		const mondayIdList = dataListing && dataListing[idString];
		const mondayId = (mondayIdList && pathId) ? mondayIdList[pathId] : null;
		const sourceMonday = type === C.TYPES.NGO ? cidList.includes(pathId) : campiagnList.includes(pathId);

		let totalMoney = null;
		const pvTotal = !noId && DataStore.fetch(
			['data', 'donations', pathId], () => ServerIO.getDonationsData({ q: idString + ":" + pathId })
		);
		if (pvTotal.resolved && pvTotal.value) {
			totalMoney = new Money(pvTotal.value.total);
		}

		return (<>
			<p>Donation Total : {totalMoney ? totalMoney.toString() : 'Loading...'}</p>
			<p>Donaton Source : {sourceMonday ? 
				<LinkOut href={"https://good-loop.monday.com/boards/"+mondayBoardId+"/pulses/"+mondayId}>
					Monday.com ID: {mondayId}
				</LinkOut> : 'Datalog'}
			</p>
		</>);
	}

	const handleButtonClick = (dType) => {
		const serverType = DataStore.getUrlValue("server");
		window.location.href = "/#donation" + (serverType ? "?server=" + serverType : "");
		setType(dType);
	};

	return (<Container>
		<h1>Donation Page</h1>
		<p>Reference: <a href="https://lg.good-loop.com/data?dataspace=crm&q=evt:dntnmon"
			target="blank" rel="noopener noreferrer">https://lg.good-loop.com/data?dataspace=crm&q=evt:dntnmon</a>
		</p>

		{!noId ? <span>You selected: <a href={`/#${typeLowercase}/` + pathId}>{typeLowercase + "/" + pathId}</a></span> : <span>Please select a campaign or charity</span>}

		<Row>
			<Col xs={2}>
				{donationTypes.map((donationType, index) => (
					<Button key={index} className="w-100" onClick={() => handleButtonClick(donationType.value)}>
						{donationType.name}
					</Button>
				))}
			</Col>
			<Col xs={10}>
				{noId ? <ListLoad type={type} sort="" canFilter otherParams={{ unlisted: true }} status={KStatus.PUB_OR_DRAFT} /> : <></>}
				{!noId && <DonationDetails />}
			</Col>
		</Row>
	</Container>);
}

export default DonationPage;
